'use strict';

function CompanyShareLinksService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/share-links', {}, {});
}

angular.module('dokiv')
  .factory('CompanyShareLinksService', ['$resource', 'config', CompanyShareLinksService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/comments/CompanyShareLinksService.js
// module id = 327
// module chunks = 0